import { render, staticRenderFns } from "./ContentPreviewAdditionalContent.vue?vue&type=template&id=24b609ce&scoped=true&"
import script from "./ContentPreviewAdditionalContent.vue?vue&type=script&lang=js&"
export * from "./ContentPreviewAdditionalContent.vue?vue&type=script&lang=js&"
import style1 from "./ContentPreviewAdditionalContent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b609ce",
  null
  
)

export default component.exports